// extracted by mini-css-extract-plugin
export default {"breadcrumb__list":"Breadcrumbs_breadcrumb__list__OjzjG","breadcrumb__link":"Breadcrumbs_breadcrumb__link__1LZxw"};